import Image from "next/image";

interface TrustCardProps {
  logoSrc: string;
  company: string;
}

const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;

const TrustCard: React.FC< TrustCardProps> = ({ logoSrc, company  }) =>  {
  return (
    <div
      className="flex justify-between md:px-6 px-4 md:pb-[18px] pb-3.5 md:pt-6 pt-4 items-start flex-col aspect-square w-full border border-border-light
    bg-[url(/images/trust-slide-opaque.webp)] bg-cover bg-no-repeat bg-center"
    >
      <div className="md:max-h-[80px] max-h-10">
        <Image
          src={`${baseUrl}${logoSrc}`}
          alt={`${company} logo`}
          width={151}
          height={35}
          quality={80}
          className="grayscale-100 brightness-100 w-auto h-auto min-h-[26px] sm:min-h-[30px] md:min-h-[35px] max-w-full max-h-full object-contain object-left-top"
        />
      </div>
      <div>
        <h6 className="text-primary-text text-subtitle-1 sm:text-heading-6 font-bold uppercase md:break-normal break-all">
          {company}
        </h6>
      </div>
    </div>
  );
};
export default TrustCard;